import React from 'react'
import styles from './Report.module.scss'
import { useCurrentTheme } from '../../hooks/useCurrentTheme'
import { getContrastColor } from '../../helpers/helpers'

export function PositionCard({ position, ...rest }) {
	const { positions } = useCurrentTheme()

	return (
		<span
			{...rest}
			className={styles.statPosition}
			style={{ backgroundColor: positions[position], color: getContrastColor(positions[position]) }}
		>
			{position}
		</span>
	)
}
